// src/Pages/MyAccount.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { green, red } from '@mui/material/colors';
import { getCookie } from '../utils/cookieUtils';
import { fetchUserDetails } from '../DatabaseApis/DBQuery';

const MyAccount = () => {
  const [activityStatus, setActivityStatus] = useState('active');
  const [userRole, setUserRole] = useState('');
  const [email, setEmail] = useState('');
  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = getCookie('userData');
    if (userData?.email) {
      setEmail(userData.email);
    }

    if (userData?.token) {
      const getUserDetails = async () => {
        try {
          const data = await fetchUserDetails(userData.token);
          setUserRole(data.role || '');
          setUserId(data.userId || userData.userId || '');
          setUserName(data.userName || userData.userName || '');
        } catch (error) {
          console.error('Error fetching user details:', error);
        } finally {
          setLoading(false);
        }
      };
      getUserDetails();
    } else {
      setLoading(false);
    }
  }, []);

  const handleStatusChange = (event) => {
    setActivityStatus(event.target.value);
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>My Account</Typography>
      <TextField
        label="Username"
        value={userName}
        fullWidth
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
      />
      <TextField
        label="User ID"
        value={userId}
        fullWidth
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
      />
      <TextField
        label="Email"
        value={email}
        fullWidth
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
      />
      <TextField
        label="Role"
        value={userRole}
        fullWidth
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
        sx={{
          '& .MuiInputBase-input': {
            color: (userRole === 'Admin' || userRole === 'Tenant Admin') ? green[700] : 'inherit',
            fontWeight: (userRole === 'Admin' || userRole === 'Tenant Admin') ? 'bold' : 'normal',
          }
        }}
      />
      <FormControl fullWidth margin="normal">
        <InputLabel id="activity-status-label">Activity Status</InputLabel>
        <Select
          labelId="activity-status-label"
          value={activityStatus}
          onChange={handleStatusChange}
          sx={{
            color: activityStatus === 'active' ? green[500] : red[500],
          }}
        >
          <MenuItem value="active" sx={{ color: green[500] }}>Active</MenuItem>
          <MenuItem value="inactive" sx={{ color: red[500] }}>Inactive</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default MyAccount;